import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import axios from 'axios'; // 引入axios

import { store } from '@/store';
import context from '@/main';
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 99999
});
var acitveAxios = 0;
var timer, requestUrl, data;
var isLoggingOut = false;
var showLoading = function showLoading() {
  acitveAxios++;
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(function () {
    if (acitveAxios > 0) {
      context.$bus.emit('showLoading');
    }
  }, 400);
};
var closeLoading = function closeLoading() {
  acitveAxios--;
  if (acitveAxios <= 0) {
    clearTimeout(timer);
    context.$bus.emit('closeLoading');
  }
};
// http request 拦截器
service.interceptors.request.use(function (config) {
  // 如果正在退出登录，不再发送任何请求
  if (isLoggingOut) {
    return Promise.reject(new Error('正在退出登录'));
  }
  if (!config.donNotShowLoading) {
    requestUrl = config.url;
    data = config.data ? config.data.startTime ? config.data.startTime : null : null;
    if (requestUrl !== '/payment/showPayLineData' || requestUrl === '/payment/showPayLineData' && !data) showLoading();
  }
  var token = store.getters['user/token'];
  var user = store.getters['user/userInfo'];

  // Google验证码相关的白名单接口
  var googleWhitelistUrls = ['/base/login', '/base/captcha', '/google/generateGoogleCode', '/google/bindingGoogleCode'];

  // 检查用户是否需要强制绑定Google验证码
  if (token && user && !user.totpSecret && !googleWhitelistUrls.includes(config.url)) {
    // 用户已登录但未绑定Google验证码，且不在白名单内，强制退出
    console.warn('用户未绑定Google验证码，强制退出登录');
    store.commit('user/LoginOut');
    return Promise.reject(new Error('需要绑定Google验证码'));
  }
  config.data = JSON.stringify(config.data);
  config.headers = {
    'Content-Type': 'application/json',
    'x-token': token,
    'x-user-id': user.ID
  };

  // 只有当 blackBox 有值时才添加到请求头
  if (store.state.user.blackBox) {
    config.headers['black-box'] = store.state.user.blackBox;
  }
  return config;
}, function (error) {
  closeLoading();
  _Message({
    showClose: true,
    message: error,
    type: 'error'
  });
  return error;
});

// http response 拦截器
service.interceptors.response.use(function (response) {
  closeLoading();
  if (response.headers['new-token']) {
    store.commit('user/setToken', response.headers['new-token']);
  }
  if (response.data.code === 0 || response.headers.success === 'true') {
    return response.data;
  } else {
    // code 10001 表示需要退出登录
    if (response.data.code === 10001) {
      isLoggingOut = true;
      _Message({
        showClose: true,
        message: response.data.msg || '登录已过期，请重新登录',
        type: 'error'
      });
      setTimeout(function () {
        store.commit('user/LoginOut');
      }, 2000);
      return response.data;
    }
    _Message({
      showClose: true,
      message: response.data.msg || decodeURI(response.headers.msg),
      type: response.headers.msgtype || 'error'
    });
    if (response.data.data && response.data.data.reload) {
      store.commit('user/LoginOut');
    }
    return response.data.msg ? response.data : response;
  }
}, function (error) {
  closeLoading();
  if (requestUrl !== '/payment/showPayLineData' || requestUrl === '/payment/showPayLineData' && !data) {}
  return error;
});
export default service;